import { Editor } from 'ckeditor5';

export const exportCKEdiorPDF = (editorInstance: Editor | null) => {
  if (editorInstance) {
    const config = editorInstance.config.get('exportPdf');
    editorInstance.execute('exportPdf', config);
  }
};
